import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-flask-line',
    title: 'Hazardous Material Removal',
    desc: 'Safe identification, containment, and regulated disposal of industrial and commercial hazardous substances per EPA standards.',
    img: 'https://public.readdy.ai/ai/img_res/f0d96130d9e093f71d13d9d76c55a1fe.jpg',
    tag: 'Industrial',
  },
  {
    icon: 'ri-building-line',
    title: 'Asbestos Abatement',
    desc: 'Certified inspection, testing, removal, and disposal of asbestos-containing materials in full compliance with all state and federal regulations.',
    img: 'https://readdy.ai/api/search-image?query=asbestos%20abatement%20workers%20in%20white%20full-body%20Tyvek%20coveralls%20and%20half-face%20respirators%20carefully%20removing%20damaged%20ceiling%20tiles%20inside%20old%20commercial%20building%20heavy%20plastic%20sheeting%20containment%20barriers%20HEPA%20vacuum%20equipment%20dramatic%20interior%20work%20lighting%20professional%20certified%20abatement%20procedure%20documentary%20photography%20dark%20moody%20tones&width=600&height=420&seq=ecos-svc3-002&orientation=landscape',
    tag: 'Regulated',
  },
  {
    icon: 'ri-drop-line',
    title: 'Mold Remediation',
    desc: 'Complete mold assessment, air quality testing, containment, and certified removal restoring structural integrity and safe air quality.',
    img: 'https://readdy.ai/api/search-image?query=mold%20remediation%20specialists%20in%20white%20protective%20suits%20and%20N95%20respirators%20treating%20severe%20black%20mold%20growth%20on%20damp%20concrete%20basement%20walls%20with%20professional%20antifungal%20spray%20equipment%20industrial%20HEPA%20air%20scrubbers%20running%20plastic%20containment%20barriers%20close-up%20dramatic%20interior%20lighting%20documentary%20photography%20muted%20dark%20tones%20professional%20environmental%20remediation&width=600&height=420&seq=ecos-svc3-003&orientation=landscape',
    tag: 'Health & Safety',
  },
  {
    icon: 'ri-alert-line',
    title: 'Disaster Restoration',
    desc: 'Rapid emergency response for flood, fire, and contamination events. Immediate containment, cleanup, and full site restoration.',
    img: 'https://readdy.ai/api/search-image?query=disaster%20restoration%20emergency%20response%20crew%20inside%20fire%20and%20smoke%20damaged%20commercial%20building%20charred%20walls%20soot-covered%20surfaces%20workers%20in%20protective%20gear%20industrial%20air%20scrubbers%20and%20water%20extraction%20equipment%20emergency%20lighting%20dramatic%20dark%20documentary%20cinematic%20photography%20urgency%20professional%20Colorado%20restoration%20service&width=600&height=420&seq=ecos-svc3-004&orientation=landscape',
    tag: 'Emergency 24/7',
  },
  {
    icon: 'ri-paint-line',
    title: 'Lead-Based Paint Removal',
    desc: 'Professional lead paint assessment and certified removal services protecting occupant health and ensuring regulatory compliance.',
    img: 'https://readdy.ai/api/search-image?query=certified%20lead%20paint%20abatement%20worker%20in%20full%20protective%20Tyvek%20suit%20respirator%20and%20safety%20goggles%20using%20HEPA%20vacuum%20sander%20on%20old%20peeling%20lead-painted%20window%20frame%20interior%20building%20renovation%20plastic%20containment%20sheeting%20professional%20lead%20removal%20procedure%20sharp%20documentary%20photography%20industrial%20warm%20tones%20EPA%20compliance&width=600&height=420&seq=ecos-svc3-005&orientation=landscape',
    tag: 'Compliance',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Environmental Consulting',
    desc: 'Expert regulatory guidance, Phase I & II site assessments, and compliance documentation tailored to your specific project requirements.',
    img: 'https://readdy.ai/api/search-image?query=environmental%20compliance%20consultant%20in%20hard%20hat%20and%20high-visibility%20vest%20conducting%20outdoor%20site%20assessment%20at%20industrial%20property%20holding%20clipboard%20with%20inspection%20checklist%20Colorado%20mountains%20and%20sky%20in%20background%20professional%20documentary%20photography%20authoritative%20expert%20pose%20muted%20earth%20and%20forest%20green%20tones&width=600&height=420&seq=ecos-svc3-006&orientation=landscape',
    tag: 'Advisory',
  },
];

export default function ServicesOverview() {
  return (
    <section id="services" className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-6">
            <p className="text-ecos-green text-xs uppercase tracking-widest font-semibold mb-4">What We Do</p>
            <h2 className="font-serif text-ecos-charcoal text-4xl lg:text-5xl font-semibold leading-tight">
              Environmental Services Built for Compliance &amp; Safety
            </h2>
          </div>
          <div className="lg:col-span-6 flex flex-col items-start lg:items-end gap-4">
            <p className="text-ecos-text text-base leading-relaxed lg:text-right max-w-md">
              From emergency response to long-term compliance planning — ECOS Environmental delivers certified results across every environmental discipline.
            </p>
            <Link
              to="/services/asbestos-abatement"
              className="inline-flex items-center gap-2 border border-ecos-green text-ecos-green hover:bg-ecos-green hover:text-white font-medium text-sm px-6 py-3 rounded-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              View All Services
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((svc) => (
            <Link
              key={svc.title}
              to="/services/asbestos-abatement"
              className="group block border border-ecos-border rounded-sm overflow-hidden hover:border-ecos-green transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <div className="w-full h-52 overflow-hidden relative">
                <img
                  src={svc.img}
                  alt={`${svc.title} — ECOS Environmental Colorado`}
                  title={`${svc.title} services`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ecos-charcoal/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-ecos-charcoal/80 text-white text-xs font-medium px-3 py-1 rounded-sm">
                    {svc.tag}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-ecos-green-pale group-hover:bg-ecos-green-pale rounded-sm flex-shrink-0">
                    <i className={`${svc.icon} text-ecos-green text-base`}></i>
                  </div>
                  <h3 className="font-serif text-ecos-charcoal text-lg font-semibold group-hover:text-ecos-green transition-colors leading-snug">{svc.title}</h3>
                </div>
                <p className="text-ecos-text text-sm leading-relaxed mb-4">{svc.desc}</p>
                <div className="flex items-center gap-1.5 text-ecos-green text-sm font-medium group-hover:gap-2.5 transition-all duration-200">
                  Learn More
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
